export default "__VITE_ASSET__7asaS72L__"